import http, { expandURI } from '@/utils/ajax'
import { MYIP_INIT_LOADING, MYIP_INIT_SUCCESS, MYIP_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'

const state = {
  myInforcedProposals: {
    init: 0,
    menu: {},
    noQuote: null,
    lastUpdated: null,
    scope: null,
    info: null,
    appIds: []
  }
}

const getters = {

}

const actions = {
  async initMyInforcedProposals({ commit, state }, data) {
    commit(MYIP_INIT_LOADING)
    const apiUrl = state.permitWidgets.myInforcedProposals
    if (apiUrl) {
      try {
        let params = {
          from: formatDisplayDateTime2(data.from),
          to: formatDisplayDateTime2(data.to)
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)
        Object.assign(data, {
          menu: menu,
          noQuote: result.data.noQuote,
          info: result.data.info,
          appIds: result.data.appIds
        })
        commit(MYIP_INIT_SUCCESS, data)
      } catch (error) {
        commit(MYIP_INIT_FAIL)
      }
    } else {
      commit(MYIP_INIT_FAIL)
    }
  }
}

const mutations = {
  [MYIP_INIT_LOADING](state) {
    state.myInforcedProposals.init = 0
  },
  [MYIP_INIT_SUCCESS](state, data) {
    const { myInforcedProposals } = state
    myInforcedProposals.menu = data.menu
    myInforcedProposals.init = 1
    myInforcedProposals.lastUpdated = new Date()
    myInforcedProposals.scope = data.scope
    myInforcedProposals.noQuote = data.noQuote
    myInforcedProposals.info = data.info
    myInforcedProposals.appIds = data.appIds
  },
  [MYIP_INIT_FAIL](state) {
    state.myInforcedProposals.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
